import { render } from "./WageInfo.vue?vue&type=template&id=829546e0&scoped=true"
import script from "./WageInfo.vue?vue&type=script&lang=js"
export * from "./WageInfo.vue?vue&type=script&lang=js"

import "./WageInfo.vue?vue&type=style&index=0&id=829546e0&lang=scss&scoped=true"

import exportComponent from "E:\\DevWorkspaces\\WorkSpaces\\sts3.9.9\\ZhaoTong\\laborEmpWeb\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-829546e0"]])

export default __exports__